import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
// Components

import moment from "moment";

// actions
import * as enablementAction from "../../../actions/partnerPortal/enablement/EnablementAction";

// Scss
import "../../../assets/css/partnerPortal/appDeveloper.scss";
import "../../../assets/css/partnerPortal/salesEnablement.scss";
import "../../../assets/css/partnerPortal/sales.scss";
import "../../../assets/css/partnerPortal/welcome.scss";
import "../../../assets/css/partnerPortal/calendar.scss";

import SubscriptionRequestDTO from "../../../models/SubscriptionRequestDTO";
import UnsubscriptionRequestDTO from "../../../models/UnsubscriptionRequestDTO";
import { userInfo } from "os";

moment.locale("en-GB");

function SubscriptionBlock() {
  const [show, setShow] = useState(false);
  const [showUns, setShowUns] = useState(false);
  const handleClose = () => closeForm();
  const handleShow = () => setShow(true);
  const handleShowUns = () => setShowUns(true);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [apiResponse, setApiResponse] = useState(<span></span>);
  const [partnerData, setPartnerData] = useState({} as any);

  const [form, setForm] = useState({
    email: "",
    name: "",
    REGIONS: [],
    TRAINING: [],
  });

  // localStorage from zinfi to input field
  // Listen for messages from the parent

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== "https://partners.dynatrace.com") return;
      console.log("Received from parent:", event.data);
      setPartnerData(event.data);
      setForm((prevForm) => ({
        ...prevForm,
        email: event.data.email,
        name: event.data.first_name + " " + event.data.last_name,
      }));

      // Send a message back to the parent
      if (event.source) {
        (event.source as Window)?.postMessage(
          "Hello from iframe",
          event.origin
        );
      }
    };
    console.log("partnerData test:", partnerData);
    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [partnerData]);
  //   "message",
  //   function (event) {
  //     var origin = event.origin; // For Chrome, the origin property is in the event.originalEvent object.
  //     if (origin !== "https://partners.dynatrace.com") {
  //       return;
  //     }

  //     if (typeof event.data === "object" && event.data.call === "sendValue") {
  //       // Do something with event.data.value;
  //       var userInfo = event.data;
  //       if (origin === "https://partners.dynatrace.com") {
  //         console.log(userInfo);
  //         setForm({
  //           ...form,
  //           email: userInfo.email,
  //           name: userInfo.first_name + " " + userInfo.last_name,
  //         });
  //       }
  //     }
  //   },
  //   false
  // );

  return (
    <>
      <div className="d-flex flex-column align-items-center w-100">
        <div className="d-flex align-items-center justify-content-center align-self-stretch ">
          <div
            role="button"
            onClick={handleShow}
            className="w-100 d-flex justify-content-end mr-2"
          >
            <div className="d-flex align-items-center justify-content-center width39 increaseWidth100 buttonBackground paddingButtonSubs">
              <div className="buttonLettersStyle buttonBlack">Subscribe</div>
            </div>
          </div>
          <div
            role="button"
            onClick={handleShowUns}
            className="w-100 d-flex justify-content-start ml-2"
          >
            <div className="d-flex align-items-center justify-content-center width39 increaseWidth100 secondaryButtonUnsub paddingButtonSubs buttonWhite">
              <div className="buttonLettersStyle">Unsubscribe</div>
            </div>
          </div>
        </div>
      </div>

      <Modal show={showUns} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="letterType">
            Enablement notifications
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmitUns}>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="letterType">Email address</Form.Label>
              <Form.Control
                className="letterType"
                name="email"
                type="email"
                placeholder="Enter email"
                value={form.email}
                disabled={
                  form.email !== null &&
                  form.email !== undefined &&
                  form.email?.length > 0
                }
                required={true}
                onChange={onChangeForm}
              />
            </Form.Group>
            <Button onClick={handleSubmitUns} className="letterType">
              Unsubscribe all
            </Button>
            {apiResponse}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            className="letterType"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="modalClass" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title className="letterType">
            Enablement notifications
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicRegion">
              <Form.Label className="letterType">
                Training regions (time zones) you'd like to get notified about:
              </Form.Label>
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="NORAM"
                label="Americas (English)"
                name="REGIONS"
                value="NORAM"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="LATAM"
                label="Americas (Spanish)"
                value={"LATAM"}
                name="REGIONS"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="EMEA"
                label="Europe | Middle East | Africa"
                name="REGIONS"
                value="EMEA"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="APAC"
                label="Asia | Australasia"
                value={"APAC"}
                name="REGIONS"
                onChange={onChangeCheckForm}
              />
              <br></br>
              {(hasSubmitted && !form["REGIONS"]) ||
              (hasSubmitted && form["REGIONS"].length === 0) ? (
                <span className="text-danger font-weight-bold">
                  Please insert one or more regions
                </span>
              ) : (
                ""
              )}
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicName">
              <Form.Label className="letterType">
                Training types you'd like to get notified about:
              </Form.Label>
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="ASSOCIATE"
                label="Associate Certification Bootcamp"
                value={"ASSOCIATE"}
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="PROFESSIONAL"
                label="Professional Certification Bootcamp"
                value={"PROFESSIONAL"}
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="TECHNICAL_SALES"
                label="Technical Sales Bootcamp"
                value="TECHNICAL_SALES"
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="WEBINAR"
                label="Tech Update Webinars"
                value={"WEBINAR"}
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <Form.Check
                className="letterType"
                inline
                type="checkbox"
                id="HOT"
                label="HOT sessions"
                value={"HOT"}
                name="TRAINING"
                onChange={onChangeCheckForm}
              />
              <br />
              <br></br>
              {(hasSubmitted && !form["TRAINING"]) ||
              (hasSubmitted && form["TRAINING"].length === 0) ? (
                <span className="text-danger font-weight-bold">
                  Please insert one or more training events
                </span>
              ) : (
                ""
              )}
            </Form.Group>
            <Button onClick={handleSubmit} className="letterType">
              Subscribe
            </Button>
            {apiResponse}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleClose}
            className="letterType"
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );

  async function handleSubmit(event) {
    const request = new SubscriptionRequestDTO(
      form["name"],
      form["email"],
      form["REGIONS"],
      form["TRAINING"]
    );
    setHasSubmitted(true);
    if (
      !form["REGIONS"] ||
      !form["TRAINING"] ||
      form["REGIONS"].length === 0 ||
      form["TRAINING"].length === 0
    ) {
      console.log("Please fill the region and trainings");
      return;
    }
    setApiResponse(
      <span className="ml-3 text-danger font-weight-bold">{"Waiting..."}</span>
    );
    enablementAction
      .doSubscription(request)
      .then((response) => {
        response.data.isSuccess === true
          ? setApiResponse(
              <span className="ml-3 text-danger font-weight-bold">
                {"Subscription done"}
              </span>
            )
          : setApiResponse(
              <span className="ml-3 text-danger font-weight-bold">
                {"Something went wrong. Try again later."}
              </span>
            );
      })
      .catch((err) => {
        console.error("subscription failed", err);
        setApiResponse(
          <span className="ml-3 text-danger font-weight-bold">
            {"Something went wrong. Try again later."}
          </span>
        );
      });
  }

  async function handleSubmitUns(event) {
    const request = new UnsubscriptionRequestDTO(form["email"]);

    setApiResponse(
      <span className="ml-3 text-danger font-weight-bold">{"Waiting..."}</span>
    );
    enablementAction
      .unsubscribe(request)
      .then((response) => {
        response.data.isSuccess === true
          ? setApiResponse(
              <span className="ml-3 text-danger font-weight-bold">
                {"Unsubscription done"}
              </span>
            )
          : setApiResponse(
              <span className="ml-3 text-danger font-weight-bold">
                {"Something went wrong. Try again later."}
              </span>
            );
      })
      .catch((err) => {
        console.error("subscription failed", err);
        setApiResponse(
          <span className="ml-3 text-danger font-weight-bold">
            {"Something went wrong. Try again later."}
          </span>
        );
      });
  }

  function closeForm() {
    let temp = form;
    temp["REGIONS"] = [];
    temp["TRAINING"] = [];
    setForm(temp);
    setApiResponse(<span></span>);
    setHasSubmitted(false);
    setShow(false);
    setShowUns(false);
  }

  function onChangeForm(e) {
    const name = e.target.name;
    const value = e.target.value;
    setForm({ ...form, [name]: value });
  }

  function onChangeCheckForm(e) {
    const fieldName = e.target.name;
    let temp = form[fieldName] || [];
    const isChecked = e.target.checked;
    const valueField = e.target.value;

    if (isChecked) {
      temp.push(valueField);
    } else {
      let index = temp.indexOf(valueField);
      temp.splice(index, 1);
    }

    setForm({ ...form, [fieldName]: temp });
  }
}

export default SubscriptionBlock;
